<template>
  <b-row>
    <b-col class="col-md-12 col-12">
      <div class="tt-alert-block">
        <transition
          name="alert-slide-fade"
          leave-active-class="animate__animated animate__fadeOutUp"
        >
          <b-alert
            variant="success"
            size="lg"
            show=""
            v-if="savingStatus === 'successSave'"
            >New expense saved successfully</b-alert
          >
        </transition>
        <transition
          name="alert-slide-fade"
          leave-active-class="animate__animated animate__fadeOutUp"
        >
          <b-alert
            variant="danger"
            size="lg"
            show=""
            v-if="savingStatus === 'failedSave'"
            >There was a problem saving your expense. Please try again</b-alert
          >
        </transition>
      </div>
      <h2 class="text-center font-weight-bold mb-0">Expense</h2>
      <validation-observer v-slot="{ invalid }" ref="observer">
        <b-form @submit.prevent="saveExpense" class="tt-mt">
          <div class="row">
            <b-form-group
              label="Pick your car"
              id="input-3"
              class="col-md-12 text-left"
              v-if="carList.length > 1"
            >
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <select
                  class="custom-select"
                  name=""
                  v-model="expense.vehicle_pouch_id"
                >
                  <option
                    v-for="car in carList"
                    :value="car._id"
                    :key="car._id"
                    :selected="car.is_default === true"
                    >{{ car.make }}</option
                  >
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Odometer"
              id="input-group-1"
              class="col-md-12 text-left"
            >
              <validation-provider
                :rules="'required|integer'"
                v-slot="{ errors }"
              >
                <b-form-input
                  type="number"
                  id="input-1"
                  v-model="expense.odometer"
                ></b-form-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Is this fuel?"
              id="input-group-6"
              class="col-md-12 text-left"
            >
              <b-form-radio
                v-model="expense.is_fuel"
                name="some-radios"
                :value="true"
                >Yes</b-form-radio
              >
              <b-form-radio
                v-model="expense.is_fuel"
                name="some-radios"
                :value="false"
                >No</b-form-radio
              >
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              label="Litres of fuel put in"
              id="input-group-7"
              class="col-md-12 text-left"
              v-if="expense.is_fuel"
            >
              <validation-provider
                :rules="'required|integer'"
                v-slot="{ errors }"
              >
                <b-form-input
                  id="input-1"
                  v-model="expense.fuel_quantity"
                  type="number"
                ></b-form-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="What was it for?"
              id="input-3"
              class="col-md-12 text-left"
            >
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <select
                  class="custom-select"
                  name=""
                  v-model="expense.description"
                >
                  <option
                    v-for="type in expenseType"
                    :value="type"
                    :key="type"
                    >{{ type }}</option
                  >
                </select>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Cost(ZAR)"
              id="input-group-3"
              class="col-md-12 text-left"
            >
              <validation-provider
                :rules="'required|integer'"
                v-slot="{ errors }"
              >
                <b-form-input
                  type="number"
                  id="input-1"
                  v-model="expense.cost"
                ></b-form-input>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Time"
              id="input-group-4"
              class="col-md-12 text-left"
            >
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <datetime
                  type="datetime"
                  :format="'ff'"
                  v-model="expense.purchase_time"
                  :value="expense.purchase_time"
                  :input-class="{
                    'form-control': true,
                    'is-invalid': errors[0]
                  }"
                ></datetime>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
            <b-form-group id="input-group-5" class="col-md-12 text-left">
              <div>
                <b-button
                  type="submit"
                  class="align-content-start mt-5 btn text-white btn-primary pl-5 pr-5 tt-border-radius w-100"
                  :disabled="invalid"
                  >Save Expense</b-button
                >
              </div>
            </b-form-group>
          </div>
        </b-form>
      </validation-observer>
    </b-col>
    <b-col class="col-12">
      <div class="mt-3">
        <hr />
        <expense
          :limit="true"
          @changeEditedExpense="updateEditedExpense"
        ></expense>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { Datetime } from "vue-datetime";
import { DateTime as TimeFormatter } from "luxon";
import Expense from "@/views/Expense";

import "vue-datetime/dist/vue-datetime.css";
import { mapGetters, mapState } from "vuex";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { integer, required } from "vee-validate/dist/rules";
import sha1 from "js-sha1";

extend("required", {
  ...required,
  message: "This field is required"
});
extend("integer", {
  ...integer,
  message: "Please input numbers only"
});

export default {
  name: "NewExpense",
  components: { Expense, Datetime, ValidationObserver, ValidationProvider },
  data() {
    return {
      newExpense: {
        type: "expense",
        is_synced: false,
        is_default: false,
        is_deleted: false,
        vehicle_pouch_id: "default",
        _id: new Date().toISOString(),
        odometer: "",
        hash: "",
        description: "",
        cost: "",
        fuel_quantity: "",
        is_fuel: false,
        status: 0,
        belongs_to_default_car: true,
        purchase_time: new Date().toISOString(),
        time: new Date().toISOString()
      },
      newEditedExpense: "",
      expenseType: [
        "Maintenance/repairs",
        "Oil",
        "Insurance",
        "Licensing",
        "Interest/finance charges"
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.expense.vehicle_pouch_id = this.defaultVehicle._id;
      this.$store.dispatch(
        "expense/getLastTripAction",
        this.defaultVehicle._id
      );
    }, 1000);
    this.$store.dispatch("expense/getExpensesAction");
    this.newExpense.hash = sha1(new Date().toISOString() + Math.random());
  },
  methods: {
    saveExpense: function() {
      //changing date format before saving
      this.expense.time = TimeFormatter.fromISO(this.expense.time).toFormat(
        "y-MM-dd H:m:s"
      );

      //Todo : could be done in a better way

      this.$store.commit("expense/save", this.expense);
      this.$refs.observer.reset();
      this.resetForm();
      this.$root.$emit("newRecordSaved");
      this.$emit("reRenderComp");
    },
    resetForm: function() {
      this.expense._id = new Date().toISOString();
      this.expense.description = "";
      this.expense.cost = "";
      this.expense.fuel_quantity = "";
      this.expense.is_fuel = false;
      this.expense.vehicle_pouch_id = this.defaultVehicle._id;
      this.expense.time = "";
      this.expense.belongs_to_default_car = true;
      this.status = 0;
      this.purchase_time = new Date().toISOString();
      this.time = new Date().toISOString();
      this.newExpense.hash = sha1(new Date().toISOString() + Math.random());
    },
    setDefaultVehicleId: function() {
      try {
        this.newExpense.vehicle_pouch_id = this.defaultVehicle._id;
      } catch (e) {
        return false;
      }
    },
    updateEditedExpense: function(val) {
      this.newEditedExpense = val;
    },
    //ensure edited trip is set on offline mode in case it was synced before
    setIsSyncedFalse: function() {
      this.$route.params.editableExpense.is_synced = false;
    }
  },
  computed: {
    ...mapGetters({
      lastRecordedExpenseOdo: "expense/getLastOdo",
      defaultVehicle: "car/getDefaultCar",
      getDefaultCarsList: "car/getDefaultCarsList",
      getUsersSavedCarsList: "car/getUsersSavedCarsList",
      carsArr: "car/getCarsArray"
    }),
    ...mapState({
      // vehicles: state => state.car.allCars,
      lastTripOdo: state => state.expense.lastRecordedTrip,
      error: state => state.trip.actionErrorMsg,
      success: state => state.trip.actionSuccessMsg
    }),
    savingStatus() {
      return this.error || this.success;
    },
    expense: function() {
      if (this.newEditedExpense) {
        window.scrollTo(0, 0);
        return this.newEditedExpense;
      } else if ("editableExpense" in this.$route.params) {
        window.scrollTo(0, 0);
        return this.$route.params.editableExpense;
      } else {
        this.setDefaultVehicleId();
        return this.newExpense;
      }
    },
    carList: function() {
      return [this.defaultVehicle, ...this.getUsersSavedCarsList];
    }
  },
  watch: {
    "expense.is_fuel": function() {
      if (!this.expense.is_fuel) {
        this.expense.fuel_quantity = "";
        // this.expense.description ='Bought fuel';
      }
    },
    lastTripOdo: function(value) {
      if (
        value &&
        parseInt(value.final_odometer) > parseInt(this.lastRecordedExpenseOdo)
      ) {
        this.expense.odometer = value.final_odometer;
      } else {
        this.expense.odometer = this.lastRecordedExpenseOdo;
      }
    },
    "expense.time": function() {
      this.expense.time = new Date().toISOString();
    },
    "expense.saved_at": function() {
      this.expense.saved_at = new Date().toISOString();
    },
    "expense.is_synced": function() {
      this.expense.is_synced = false;
    },
    defaultVehicle: function(value) {
      this.expense.vehicle_pouch_id = value._id;
      this.$store.dispatch("expense/getLastTripAction", value._id);
    },
    "expense.vehicle_pouch_id": function(pouch_car_id) {
      this.$store.dispatch("expense/getLastTripAction", pouch_car_id);
      this.expense.belongs_to_default_car =
        this.carsArr[pouch_car_id].is_default_car || false;
    }
  },
  beforeDestroy() {
    this.$store.commit("trip/resetValue");
  }
};
</script>

<style scoped>
.btn-primary.disabled,
.btn-primary:disabled {
  color: #212529;
  background-color: #54d387;
  border-color: #54d387;
}
</style>
